export default __webpack_public_path__ + "images/17172153379488d1705693cfc85a8f2d-logo.svg";